import { helpers } from "vuelidate/lib/validators"

export const validatePhoneNumber = (value: string) => !helpers.req(value) || /^\(\d{3}\) \d{3}-\d{4}$/.test(value)
